export default __webpack_public_path__ + "static/media/Thumb_Skin_iridescent.81bb1910.png";